import { ENVIRONMENT, IS_NON_PROD, API_BASE_URL } from '@/env';

// Slim, sticky banner shown on every page when VITE_ENVIRONMENT is anything
// other than 'production'. Prevents the "I just deleted that user in… oh no"
// moment by making the active environment unmistakable.
export function EnvBanner() {
  if (!IS_NON_PROD) return null;

  const label = ENVIRONMENT.toUpperCase();
  const palette: Record<string, { bg: string; text: string }> = {
    development: { bg: '#1f1f1f', text: '#fafafa' },
  };
  const { bg, text } = palette[ENVIRONMENT] ?? palette.development;

  return (
    <div
      style={{ backgroundColor: bg, color: text }}
      className="w-full text-center text-xs font-medium tracking-wide py-1 px-3 select-none"
      role="status"
      aria-label={`This is the ${label} environment`}
    >
      <span className="font-mono">{label}</span>
      <span className="opacity-70"> · {API_BASE_URL}</span>
    </div>
  );
}
